/**
 * Detecção "dentro da WebView do app" — mesma técnica já validada em Renewal.tsx:
 * a bridge window.ReactNativeWebView só existe injetada pelo react-native-webview.
 * Não há query param equivalente (decisão: posse da bridge > param forjável).
 */
export const isInApp = (): boolean =>
  typeof window !== 'undefined' &&
  !!(window as unknown as { ReactNativeWebView?: unknown }).ReactNativeWebView;

/**
 * Versão do contrato app ↔ checkout (#133). Espelho: app/src/utils/appBridge.ts.
 *
 * O checkout deploya em minutos; o app instalado leva semanas pra atualizar.
 * Sem `version`, uma mudança incompatível aqui quebrava o app em silêncio
 * (`catch {}` no onMessage). Agora o app rejeita versão desconhecida e avisa
 * o Sentry. Ao subir: manter o app aceitando as duas por um ciclo de build.
 *
 * Tipos: purchase-complete { loginToken?, email? } · renewal-close ·
 * card-changed { charged }.
 */
export const APP_BRIDGE_VERSION = 1;

export function postToApp(message: { type: string } & Record<string, unknown>): void {
  const bridge = (
    window as unknown as {
      ReactNativeWebView?: { postMessage?: (data: string) => void };
    }
  ).ReactNativeWebView;
  bridge?.postMessage?.(JSON.stringify({ version: APP_BRIDGE_VERSION, ...message }));
}
